import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import DaModal from './DaModal';
const Modals = (_param)=>{
    var { modals = [] } = _param, rest = _object_without_properties(_param, [
        "modals"
    ]);
    var _modals, _renderedModals;
    if (modals.length === 0) {
        return null;
    }
    const renderedModals = (_modals = modals) === null || _modals === void 0 ? void 0 : _modals.map((modal, index)=>/*#__PURE__*/ React.createElement(DaModal, _object_spread_props(_object_spread({
            modal: modal
        }, rest), {
            key: index
        })));
    return renderedModals ? // Typescript doesn't like us returning arrays for a React.FC return type despite it being totally fine.
    // Context here: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18912
    /*#__PURE__*/ React.createElement(React.Fragment, null, (_renderedModals = renderedModals) === null || _renderedModals === void 0 ? void 0 : _renderedModals.map((modal, index)=>/*#__PURE__*/ React.createElement(React.Fragment, {
            key: index
        }, modal))) : null;
};
Modals.displayName = 'Modals';
export default Modals;
